import { useEffect, useRef, useState } from 'react'

const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms))

// Ein Ladepfad für alle öffentlichen Seiten: lädt und hält Zustand fest.
// reloading: es lag schon einmal ein Ergebnis vor (etwa eine neue Suche).
// minReloadMs: so lange bleibt ein Nachladen mindestens im Ladezustand — der
// Server antwortet sonst schneller, als das Lade-Logo zu sehen ist. Der erste
// Ladevorgang wartet nie zusätzlich.
const useLoad = (loader, deps = [], { minReloadMs = 0 } = {}) => {
    const [state, setState] = useState({ data: null, loading: true, reloading: false, error: '' })
    const geladen = useRef(false)

    useEffect(() => {
        let active = true
        const reloading = geladen.current
        setState({ data: null, loading: true, reloading, error: '' })

        const mindestens = reloading && minReloadMs > 0 ? wait(minReloadMs) : Promise.resolve()
        const fertig = (next) => mindestens.then(() => {
            if (!active) return
            geladen.current = true
            setState({ ...next, loading: false, reloading: false })
        })

        loader()
            .then(data => fertig({ data, error: '' }))
            .catch(e => fertig({ data: null, error: e.message || 'error' }))

        return () => { active = false }
    }, deps)

    return state
}

export default useLoad
